import { ProspectActionKind } from "@prisma/client";
import { ProspectActionRow } from "@/app/types/prospect/ProspectAction";

export enum ProspectActionFilterMode {
  ALL = "all",
  NONE = "none",
  KIND = "kind",
  TYPE = "type",
}

export type ProspectActionFilter = {
  mode: ProspectActionFilterMode;
  kind?: ProspectActionKind;
  typeId?: number;
};

export const PROSPECT_ACTION_FILTER_ALL: ProspectActionFilter = {
  mode: ProspectActionFilterMode.ALL,
};

export function prospectActionFilterKey(filter: ProspectActionFilter): string {
  if (filter.mode === ProspectActionFilterMode.KIND) {
    return `${filter.mode}:${filter.kind}`;
  }
  if (filter.mode === ProspectActionFilterMode.TYPE) {
    return `${filter.mode}:${filter.typeId}`;
  }
  return filter.mode;
}

export function isSameProspectActionFilter(
  a: ProspectActionFilter,
  b: ProspectActionFilter,
): boolean {
  return prospectActionFilterKey(a) === prospectActionFilterKey(b);
}

export function matchesProspectActionFilter(
  actions: ProspectActionRow[] | undefined,
  filter: ProspectActionFilter,
): boolean {
  const rows = actions ?? [];

  switch (filter.mode) {
    case ProspectActionFilterMode.NONE:
      return rows.length === 0;
    case ProspectActionFilterMode.KIND:
      return rows.some((action) => action.kind === filter.kind);
    case ProspectActionFilterMode.TYPE:
      return rows.some((action) => action.type?.id === filter.typeId);
    default:
      return true;
  }
}
